export default "__VITE_PUBLIC_ASSET__b4956cd1__"